var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm ms-1",class:{ 'btn-danger': _vm.isSent, 'btn-dark': !_vm.isSent },attrs:{"type":"button","data-bs-toggle":"tooltip","title":_vm.buttonTitle,"disabled":_vm.loader},on:{"click":_vm.checkSend}},[(!_vm.loader)?_c('i',{staticClass:"fa fa-envelope"}):_c('b-spinner',{staticStyle:{"width":"16px","height":"16px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }